var _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSavetwo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    id: "master_svg0_9_900"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A073FF",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7230FF",
    stopOpacity: 1
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 18,
    height: 18,
    rx: 0,
    fill: "#D8D8D8",
    fillOpacity: 1
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2,14L2,4C2,2.89543,2.89543,2,4,2L14,2C15.1046,2,16,2.89543,16,4L16,14C16,15.1046,15.1046,16,14,16L4,16C2.89543,16,2,15.1046,2,14ZM3.2,14Q3.2,14.8,4,14.8L14,14.8Q14.8,14.8,14.8,14L14.8,4Q14.8,3.2,14,3.2L4,3.2Q3.2,3.2,3.2,4L3.2,14ZM5.69922,5.700200000000001L7.05069,5.700200000000001L7.05069,12.3002L5.69922,12.3002L5.69922,5.700200000000001ZM9.86181,12.3002L7.96116,12.3002L7.96116,5.700200000000001L9.92192,5.700200000000001Q11.36012,5.700200000000001,12.3232,6.57183Q13.2992,7.45521,13.2992,8.92466Q13.2992,10.44716,12.3294,11.37628Q11.36504,12.3002,9.86181,12.3002ZM9.89187,6.98967L9.31264,6.98967L9.31264,11.01459L9.85805,11.01459Q10.84196,11.01459,11.37589,10.47914Q11.91017,9.94332,11.91017,8.94403Q11.91017,7.9558,11.37255,7.47981Q10.81894,6.98967,9.89187,6.98967Z",
    fillRule: "evenodd",
    fill: "url(#master_svg0_9_900)",
    fillOpacity: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavetwo);
export default __webpack_public_path__ + "static/media/savetwo.d5ff74545bea6e1deebe9d3f1dbd02f6.svg";
export { ForwardRef as ReactComponent };